import styled from 'styled-components'
import { media } from '../../../layouts/utils'

import {
    colorBrandPrimary,
    fontFamily,
    colorNeutralDark,
} from '../../../global.style'

export const CardContainer = styled.div`
    width: 100%;
    min-width: 422px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    padding-top: 32px;

    ${media.phone`
        min-width: min-content;
    `}
`

export const CardImage = styled.img`
    min-width: 221px;
    width: 221px;
    height: 221px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
`
export const CardTitle = styled.h2`
    font-size: 32px;
    text-align: center;
    color: #24206b;
    padding-bottom: 16px;
`
export const CardText = styled.span`
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    width: 307px;
    padding-bottom: 24px;
    letter-spacing: 0;
    line-height: 24px;
    align-items: center;
    display: flex;
    flex-direction: column;
    align-self: ${({ alinhamento }) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};
    text-align: ${({ alinhamento }) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};

    code {
        font-family: ${fontFamily.neutral};
        font-size: 14px;
        line-height: 21px;
    }

    p {
        color: ${(props) =>
            props.corTexto ? props.corTexto.cor : colorNeutralDark['90']};
    }
    h2 {
        font-family: ${fontFamily.brand};
        font-size: 32px;
        line-height: 26px;
        font-weight: normal;
        padding-bottom: 16px;
    }
    h3 {
        font-family: ${fontFamily.brand};
        font-size: 24px;
        font-weight: normal;
        padding-bottom: 16px;
    }
    h4 {
        font-family: ${fontFamily.brand};
        font-size: 20px;
        font-weight: normal;
        padding-bottom: 16px;
    }

    ${media.phone`
        width: 272px;
        h2{
            font-size: 24px;
        }
    `}
`
export const CardBotao = styled.div`
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    a {
        align-self: flex-end;
        padding-bottom: 5px;
    }
`
